var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStorefront = function SvgStorefront(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "storefront_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#storefront_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.025 21q-.824 0-1.413-.587A1.93 1.93 0 0 1 3.026 19v-7.95q-.576-.525-.887-1.35-.313-.825-.013-1.8l1.05-3.4a2.2 2.2 0 0 1 .713-1.075A1.8 1.8 0 0 1 5.075 3h13.9q.675 0 1.175.413.5.412.725 1.087l1.05 3.4q.3.975-.012 1.775a3.95 3.95 0 0 1-.888 1.375V19q0 .824-.587 1.413a1.93 1.93 0 0 1-1.413.587zm9.2-11q.675 0 1.025-.463.35-.462.275-1.037l-.55-3.5h-1.95v3.7q0 .525.35.913.35.387.85.387m-4.5 0q.575 0 .938-.387.362-.388.362-.913V5h-1.95l-.55 3.5q-.1.6.262 1.05.363.45.938.45m-4.45 0q.45 0 .787-.325.338-.326.413-.825L7.025 5h-1.95l-1 3.35q-.15.5.162 1.075Q4.55 10 5.276 10m13.5 0q.724 0 1.05-.575.325-.575.15-1.075L18.925 5h-1.9l.55 3.85q.075.5.413.825a1.1 1.1 0 0 0 .787.325m-13.75 9h14v-7.05a.6.6 0 0 1-.162.05h-.088q-.675 0-1.187-.225-.513-.225-1.013-.725a3.3 3.3 0 0 1-1.025.7q-.575.25-1.225.25-.674 0-1.262-.25a3.3 3.3 0 0 1-1.038-.7 3.1 3.1 0 0 1-.988.7 2.95 2.95 0 0 1-1.212.25 3.3 3.3 0 0 1-1.312-.25 3.3 3.3 0 0 1-1.038-.7q-.525.525-1.037.737A3 3 0 0 1 5.275 12h-.113a.25.25 0 0 1-.137-.05z"
  }))));
};
export default SvgStorefront;